module.exports = __webpack_public_path__ + "static/media/Crowding of teeth on one jaw 11.2aafee9d.png";